import cookies from "js-cookie";

/**
 * Libellés de date des écrans de créneaux. Toujours construits depuis une clé
 * `YYYY-MM-DD` en heure locale (voir utils/slotSelection), jamais depuis une
 * date UTC : minuit UTC tombe la veille à Bruxelles en été.
 */

const LOCALES = { fn: "fr-BE", du: "nl-BE", en: "en-GB" };

export const dateLocale = () => LOCALES[cookies.get("i18next")] || "en-GB";

export const keyToDate = (key) => {
  const [year, month, day] = String(key).split("-").map(Number);

  return new Date(year, month - 1, day);
};

const capitalise = (text) => text.charAt(0).toUpperCase() + text.slice(1);

/* Intl ajoute un point aux abréviations françaises (« jeu. », « sept. ») ;
   le design n'en met pas. */
const undot = (text) => text.replace(/\./g, "");

/** « jeu » — ligne du haut d'une pastille de jour. */
export const dayOfWeek = (key, locale = dateLocale()) =>
  undot(keyToDate(key).toLocaleDateString(locale, { weekday: "short" }));

/** « 24 » — chiffre de la pastille. */
export const dayNumber = (key) => String(keyToDate(key).getDate());

/** « Jeu 24 sept » — récapitulatifs courts. */
export const shortDate = (key, locale = dateLocale()) => {
  const date = keyToDate(key);
  const weekday = undot(date.toLocaleDateString(locale, { weekday: "short" }));
  const month = undot(date.toLocaleDateString(locale, { month: "short" }));

  return capitalise(`${weekday} ${date.getDate()} ${month}`);
};

/**
 * « jeudi 1er octobre » — pour une date **au milieu d'une phrase** : pas de
 * majuscule (Intl rend déjà « Thursday » en anglais), et le premier du mois
 * s'écrit « 1er » en français.
 */
export const longDate = (key, locale = dateLocale()) => {
  const date = keyToDate(key);
  const text = date.toLocaleDateString(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  if (locale.startsWith("fr") && date.getDate() === 1) {
    return text.replace(/\b1\b/, "1er");
  }

  return text;
};
